import { Box } from '@jfs/ui-new'
import { useIsLargeScreen } from '@jfs/utils'
import { FC, useMemo, useRef, useState } from 'react'
import { Dimensions, FlatList } from 'react-native'
import { TableComponent } from '../TableComponent'
import CarousalItem from './CarousalItem'
import styles, { fullScreenStyles } from './styles'
import { CarousalItemData, CarousalProps } from './types'

const Carousal: FC<CarousalProps> = ({
  data: dataProp,
  isSnapEnabled = false,
  fullScreen = false,
  isRepeating = false,
  onSelectionChange,
  onPress,
  onClosePress,
  isVertical = false,
  isFromProfile = false,
}: CarousalProps) => {
  console.log(onClosePress)
  const { width } = Dimensions.get('screen')
  const scroller = useRef<FlatList<CarousalItemData>>(null)
  const itemWidth = isFromProfile ? width : width / 1.25 + 12

  const getItemoffset = (index: number) => index * itemWidth - 22
  const [selectedIndex, setSelectedIndex] = useState(0)

  const data = useMemo(() => {
    if (isRepeating) {
      const tempData = [...dataProp]
      dataProp.forEach((item, index) => {
        tempData.push({ ...item, key: (dataProp.length + index).toString() })
      })
      dataProp.forEach((item, index) => {
        tempData.push({ ...item, key: (2 * dataProp.length + index).toString() })
      })
      return tempData
    }
    return dataProp
  }, [dataProp, isRepeating])

  const onScroll = (event: any) => {
    if (onSelectionChange) {
      const currentlySelected = Math.floor(event.nativeEvent.contentOffset.x / itemWidth + 0.5)
      if (currentlySelected !== selectedIndex) {
        setSelectedIndex(currentlySelected)
        onSelectionChange(currentlySelected)
      }
    }
  }
  const onMomentumScrollEnd = () => {
    if (isRepeating) {
      if (selectedIndex < data.length / 3) {
        setSelectedIndex(data.length / 3 + selectedIndex)
        return scroller?.current?.scrollToOffset({
          animated: false,
          offset: getItemoffset(data.length / 3 + selectedIndex),
        })
      }
      if (selectedIndex > (2 * data.length) / 3 - 1) {
        setSelectedIndex(selectedIndex - data.length / 3)
        return scroller?.current?.scrollToOffset({
          animated: false,
          offset: getItemoffset(selectedIndex - data.length / 3),
        })
      }
    }
  }
  const onPressItem = (item: CarousalItemData, index: number) => {
    if (isRepeating) {
      return scroller?.current?.scrollToOffset({
        offset: getItemoffset(index),
      })
    }
    if (onPress) {
      onPress(item, index)
    }
  }
  const isLarge = useIsLargeScreen()

  const renderItem = ({ item, index }: any) => {
    return (
      <CarousalItem
        data={item}
        isLarge={isLarge}
        isFromProfile={isFromProfile}
        index={index}
        onPress={() => {
          onPressItem(item, index)
        }}
      />
    )
  }
  let snapToOffsets
  let getItemLayout
  let decelerationRate: 'fast' | 'normal' | number | undefined
  let disableIntervalMomentum: boolean | undefined
  if (isSnapEnabled || isRepeating) {
    snapToOffsets = data.map((_, index) => getItemoffset(index))
    getItemLayout = (_: Array<CarousalItemData> | null, index: number) => ({
      index,
      length: itemWidth,
      offset: getItemoffset(index),
    })
    decelerationRate = 'fast'
    disableIntervalMomentum = true
  }

  const containerStyle = fullScreen ? [styles.container, fullScreenStyles] : styles.container

  // const onCloseButtonPress = () => {
  //   if (onClosePress) {
  //     onClosePress()
  //   }
  // }

  return (
    <Box {...containerStyle}>
      <TableComponent
        value={''} //Routes value
        canFetchMore={false}
        hide={false}
        isCustom={true}
        ListContent={data ?? []}
        horizontal={!isVertical}
        RenderCustomElement={renderItem}
        contentContainerStyle={styles.listContainerStyle}
        customStyle={styles.flatListStyle}
        keyExtractor={(item) => item.key.toString()}
        onScroll={onScroll}
        decelerationRate={decelerationRate}
        disableIntervalMomentum={disableIntervalMomentum}
        pagingEnabled={true}
        snapToOffsets={snapToOffsets}
        getItemLayout={getItemLayout}
        innerRef={scroller}
        onMomentumScrollEnd={onMomentumScrollEnd}
      />
    </Box>
  )
}
export default Carousal
